import ErrorMonitor from '@/views/error-monitor/error-monitor.view.vue';

export default [
  {
    path: '/:projectName/monitor',
    name: 'monitor',
    component: ErrorMonitor,
  },
];
